import { Bot, Plus } from 'lucide-react'
import { useDashboardStore } from '../../store/dashboardStore'
import { useT } from '../../hooks/useTranslation'
import { useHaptic } from '../../hooks/useHaptic'

const CARD_STYLE = {
  background: '#1A1A1A',
  border: '1px solid rgba(255,255,255,0.06)',
  borderRadius: 20,
}

export default function QuickActions() {
  const t = useT()
  const haptic = useHaptic()
  const setActiveTab = useDashboardStore(s => s.setActiveTab)

  const goToBots = () => { haptic.light(); setActiveTab('bots') }

  return (
    <div className="grid grid-cols-2 gap-3 mb-5 mt-1">
      <button
        onClick={goToBots}
        className="flex flex-col items-center justify-center gap-2.5 transition-all active:scale-95"
        style={{ ...CARD_STYLE, paddingTop: 22, paddingBottom: 18 }}
      >
        <Bot size={34} color="#34D399" strokeWidth={1.5} />
        <span className="text-[15px] font-semibold text-white">{t.myBots}</span>
      </button>

      <button
        onClick={goToBots}
        className="flex flex-col items-center justify-center gap-2.5 transition-all active:scale-95"
        style={{ ...CARD_STYLE, paddingTop: 22, paddingBottom: 18 }}
      >
        <div
          className="flex items-center justify-center"
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
          }}
        >
          <Plus size={20} color="#fff" strokeWidth={2.5} />
        </div>
        <span className="text-[15px] font-semibold text-white">{t.newBot}</span>
      </button>
    </div>
  )
}
